import { Twitter } from "@mui/icons-material";

export const Bio = {
  name: "Deep Mathukiya",
  roles: [
    "ML Developer",
    "Software Developer",
    "Programmer",
  ],
  description:
    "I'm a motivated and flexible person, always excited to take on new challenges. I love learning and am committed to delivering high-quality results. With a positive attitude and a focus on growth, I'm ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/DeepMathukiya",
  mail: "mailto:dsmathukiya2004@gmail.com",
  twitter: "https://x.com/deepsmathukiya",
  resume:
  "https://drive.google.com/file/d/1ctQo1vxEzW8V-sTzAgOPWuwSEtLZaX2l/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/deepmathukiya/",
  insta: "https://www.instagram.com/deepsmathukiya/",
};

export const skills = [{
  title: "Computer Vision",
  skills: [
    {
      name: "Detection",
      image: "https://cdn-icons-png.freepik.com/512/4667/4667443.png"
    },
    {
      name: "Classification",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRwvRlNyPQSfEf3sTeKEFtAx3VZX2dbnWB87AmijUDK_9vU2UmN_z10BVaQgGF67ksJLY0&usqp=CAU"
    },
    {
      name: "Segmentation",
      image: "https://c8.alamy.com/comp/M50H4A/customer-market-segmentation-concept-on-white-background-M50H4A.jpg",
    },
    {
      name: "Tracking",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ7x_IcoONsKn05bkJHHEg29K0MrrjUCEWxuA&s"
    },
    {
      name: "Edge Device Deployment",
      image: "https://www.machinemetrics.com/hs-fs/hubfs/edge-device-1.png?width=357&name=edge-device-1.png"
    },
    {
      name: "TensorFlow",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6iQyYphUHhLEUchqyhIwsRMe0G9aqVFjUaA&s",
    },
    {
      name: "OpenCV",
      image: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/OpenCV_Logo_with_text_svg_version.svg/1662px-OpenCV_Logo_with_text_svg_version.svg.png"
    },
    {
      name: "YOLO",
      image: "https://cdn.prod.website-files.com/646dd1f1a3703e451ba81ecc/64777c3e071ec953437e6950_logo.svg"
    }, {
      name: "InsightFace",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBYmkMxrIr2yu2bjYT8-NMzQd_4DESJgApoA&s"
    },
    {
      name: "CNN",
      image: "https://cdn.educba.com/academy/wp-content/uploads/2019/10/Convolutional-Neural-Networks.png"
    }, {
      name: "LSTM",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ2BiJC3NpDGxJIbpo-8E5azr9Keudw6qGuVQ&s",
    },
    {
      name: "TensorRT",
      image: "https://docscontent.nvidia.com/dims4/default/31e9ab4/2147483647/strip/true/crop/980x552+105+0/resize/1000x563!/quality/90/?url=https%3A%2F%2Fk3-prod-nvidia-docs.s3.us-west-2.amazonaws.com%2Fbrightspot%2F1e%2Fcb%2F053bae0a4f15a0672037a721be67%2Ftensorrt-logo.png"
    },
    {
      name: "ResNet-50",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMexhmEsP3-BXXv81IxG4ibshafL0U1Is15w&s"
    },
    {
      name: "RetinaFace",
      image: "https://miro.medium.com/v2/resize:fit:1400/1*eYTZ61Y57OG_vrRU2b_MNg.png"
    },

  ]
},
{
  title: "ML + TSA ",
  skills: [
    {
      name: "Regression",
      image: "https://miro.medium.com/v2/resize:fit:1400/0*Q80QCpg5u_zOUVek.png"
    },
    {
      name: "Classification",
      image: "https://tutorialforbeginner.com/images/ml/classification-algorithm-in-machine-learning.png"
    },
    {
      name: "Time series prediction",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSM0E5hYF4jRBFekAxLmmJkUTrKG51mBGpICg&s"
    },
    {
      name: "Sk Learn Kit",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
    },

    {
      name: "Pandas",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuYdGfU_JedP54Ab0Q8qHMki1stU4Dh2BZ8w&s",

    },
    {
      name: "NumPy",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQRC2C9EVtvZjW_wQ3f9bEP2Fgla230C3kVYQ&s",
    },
    {
      name: "Matplotlib",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNW4FYu8aIfv9vdr-uK7lxMsd79VsbmuJvJQ&s",
    },
    {
      name: "PSO(Particle Swarm Optimization)",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQlP7C6404P4O1Gz1zAuugQCz9dc5yTt8KIg&s"
    },
    {
      name: "Ensemble Learning",
      image: "https://www.kdnuggets.com/wp-content/uploads/rafaat_ensemble_learning_techniques_walkthrough_random_forests_python_1.png"
    },

    {
      name: "PCA(Principal Component Analysis)",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3-yVv1ddEF_C_waFEDLlu4qod80qo9dtKyA&s"
    },
    {
      name: "SARIMAX",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQIFkH6HXkf_5b3gxT6Blh0LyEBZyF8IIKW2A&s"
    },

  ],
},
{
  title: "Web",
  skills: [

    {
      name: "MongoDB",
      image: "https://w7.pngwing.com/pngs/956/695/png-transparent-mongodb-original-wordmark-logo-icon-thumbnail.png"
    },

    {
      name: "Express Js",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTI3nGP9w-Ol7H0GYUnDUdCwqnoLwRzoe_cmA&s",
    },
    {
      name: "React Js",
      image:
        "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
    },
    {
      name: "Node.js",
      image: "https://e7.pngegg.com/pngimages/306/37/png-clipart-node-js-logo-node-js-javascript-web-application-express-js-computer-software-others-miscellaneous-text-thumbnail.png  ",
    },

    {
      name: "JavaScript",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
    },
    {
      name: "Redux",
      image:
        "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
    },

    {
      name: "PHP",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRxpsL-2QuKegg5K1fw0ff4p8ErFk2vmjwZQ&s",
    },

    {
      name: "laravel",
      image:
        "https://download.logo.wine/logo/Laravel/Laravel-Logo.wine.png"
    },
    {
      name: "MySQL",
      image:
        "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
    },
    {
      name: "Python",
      image:
        "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
    },
    {
      name: "Flask",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRFIhqNQXYFrSE3l_X_MStZ_O-59yhl0id1CA&s",
    },
    {
      name: "Django",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQqwPdqgkrKMfhAhX2gEAbLFfQK1T6r94FEZw&s"
    },
    {
      name: "HTML",
      image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
    },
    {
      name: "CSS",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
    },

    {
      name: "Bootstrap",
      image:
        "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
    },
  ],
},
{
  title: "Others",
  skills: [
    {
      name: "Docker",
      image: "https://w7.pngwing.com/pngs/219/411/png-transparent-docker-logo-kubernetes-microservices-cloud-computing-dockers-logo-text-logo-cloud-computing-thumbnail.png"
    },

    {
      name: "Hugging Face",
      image: "https://cdn.worldvectorlogo.com/logos/huggingface-2.svg"
    },
    {
      name: "Git",
      image:
        "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
    },
    {
      name: "GitHub",
      image:
        "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
    },
    {
      name: "Jupyter",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
    },
    {
      name: "Google Colab",
      image:
        "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Google_Colaboratory_SVG_Logo.svg/2560px-Google_Colaboratory_SVG_Logo.svg.png",
    },
    {
      name: "Firebase",
      image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
    },
    {
      name: "Intellij IDEA",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8fbwusxe4WMoRjHlWi_5QYN5VlDqZmwXDgQ&s",
    },

    {
      name: "XML",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
    },
    {
      name: "Android Studio",
      image:
        "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
    },
    {
      name:
        "Chaqopy",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSVlfjzr1A4B6voEIstEKE5qzQxGZ9Pf-YFVg&s",
    },
    {
      name: "gTTS",
      image: "https://pythonfix.com/pkg/g/gtts/gtts-banner.webp",
    },

    {
      name: "XAMPP",
      image:
        "https://static-00.iconduck.com/assets.00/apps-xampp-icon-256x256-h4mje2zt.png",
    },
  ],
},
];


export const experiences = [
  // {
  //   id: 0,
  //   img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/neurobit.jpeg?alt=media&token=1cacbb7b-e5ea-4efb-9b3d-f5a31b9564ad",
  //   role: "Frontend Engineer Intern",
  //   company: "Neurobit",
  //   date: "June 2023 - Nov 2023",
  //   desc: "Enhanced user experiences on Neurobit PSG & Hybrid, Portals by resolving bugs & reduced load time by 40%. Built Neurobit Analytics portal using React Js with seamless interaction of REST APIs using AXIOS optimized with React Query. Refactored previous code to TypeScript, updated with new dependency and integrated Vite with Jest for Unit Testing.",
  //   skills: [
  //    insert all skills ,
  //   ],
  // doc:  please insert document or certificate link
  // },
  // {
  //   id: ,
  //   img: "" ,
  //   role: "",
  //   company: "",
  //   date: "",
  //   desc: "",
  //   skills: [
  //     "TSA (Time Series Analysis)",
  //     "Time Series Forecasting",
  //     "ARIMA",
  //     "SARIMA",
  //     "LSTM (Long Short-Term Memory)",
  //   ]
  // },
{
    id: 6,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLBICFOe_o53CTbo2cizBGV9makhDmXwun9W8cuX7Tmw&s=10",
    role: "Ml Engineer",
    company: "HyperNorm AI",
    date: "Dec 2025 - Present",
    desc: `Architected a fully controlled, low-cost Web Search MCP tool for seamless LLM integration.\n
          Engineered LLM gateway with RBAC, 100% observability, rate/token limiting, and adding ~10 ms latency.\n
          Optimized a LangGraph financial research agent using GEPA, outperformed Perplexity on 120 queries.\n`,
    skills: [
      "Agentic Ai",
      "MCP",
      "RAG",
      "Calude Code ",
      "LangGraph",
      "LangChain",
      "LangFuse",
      "GEPA",
      "DsPy",
    ]
  },
  {
    id: 5,
    img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcBAMAAACAI8KnAAAAJ1BMVEVHcEwgnO4gnO4gnO4Pme4Ale2Rx/X+///j8f16vfRUrvHF4fqiz/dRU6LoAAAAA3RSTlMApvpfQ8SzAAAAmklEQVR4AWNgVDaGAyMBBmFjJGDIAJJESDMYowAQ1yQ0GJnrVt5KEtfEBYVrOSsEidtdXl4ZjOCCwFFUbqUzgjs1qrw8GMYFajRdXr4Ezi01Ng4vT0F2RgSc61leApKdAuUal1eHuG4vh1lkur185+zy6mCYrDnI3mJjGNcLxF0C55qEtVccdYZywcET6gz1EQpAC1i0YEeLFACfnmaCAxeM1QAAAABJRU5ErkJggg==",
    role: "AI/ML Engineer",
    company: "Buze Platforms Pvt. Ltd.",
    date: "May 2025 - Dec 2025",
    desc: "I engineered a real-time person detection, tracking, and face recognition pipeline integrating YOLO and InsightFace (Buffalo L), achieving 92% accuracy at 30 FPS. The system was optimized using TensorRT and deployed on an NVIDIA T4 GPU for high-performance inference. On the edge, I developed C++ modules for face detection and recognition on the Rockchip RV1126 platform using MPP, RockX, MTCNN, and MobileFaceNet (converted to RKNN format), resulting in low-latency processing. Additionally, I implemented bounding box-based distance estimation to enable proximity analysis between individuals. The entire deployment pipeline was automated using CMake, ensuring compatibility and streamlined builds across CUDA, ONNX, and RKNN modules for multiple embedded platforms."
    ,
    skills: [
      "MPP, RockX SDKs",
      "RKNN ",
      "YOLO",
      "ONNX",
      "TensorRT ",
      "Embedded systems",
      "OpenCV ",
      "CMake ",
      "Cross-Platform Development",
    ]
  },
  {
    id: 4,
    img: "https://upload.wikimedia.org/wikipedia/en/f/f2/India_Meteorological_Department_%28logo%29.png",
    role: "Research Intern",
    company: "India Meteorological Department",
    date: "May 2025 - Present",
    desc: "Worked under the guidance of Dr. Manorama Mohanty on a research project focused on temperature prediction using time series forecasting. My role involved collecting, preprocessing, and analyzing meteorological data to develop accurate predictive models. I implemented and evaluated various time series techniques, including ARIMA and LSTM, gaining practical experience in applied machine learning and real-world weather data modeling.",
    skills: [
      "TSA (Time Series Analysis)",
      "Time Series Forecasting",
      "ARIMA",
      "SARIMA",
      "LSTM (Long Short-Term Memory)",
    ]
  },
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMNW1DwS6DoBYNgyrnKtG9i3B3mn0I1YkvAw&s",
    role: "Student Researcher",
    company: "Pandit Deendayal Energy University",
    date: "Sep 2024 - Present",
    desc: "Conducting research on AI-driven sign language translation through the SignToSpeech project, developing real-time sign-to-speech and speech-to-sign solutions using deep learning and AR technologies. Worked with NVIDIA Jetson Nano to deploy and optimize models for real-time performance, enabling efficient edge computing for gesture recognition and translation.",
    skills: [
      "Deep Learning",
      "Computer Vision",
      "OpenCV",
    ]
  },
  {
    id: 2,
    img: "https://bnbpdeu.web.app/img/logo.png",
    role: "Tech and IT Head",
    company: "Bulls And Bear PDEU",
    date: "JULY2024 - Present",
    desc: "Led all technical aspects for Bulls & Bears, PDEU's finance club, including the creation and management of the Bazzar event website and ensuring its smooth operation during key events.",
    skills: [
      "Leadership",
      "Web Development",
      "Reactjs",
      "Node js",
      "Firebase",
    ],
  },
  {
    id: 1,
    img: "https://miro.medium.com/v2/resize:fit:799/0*ilw552fVUGbwIzbE.jpg",
    role: "Technical Team",
    company: "GFG PDEU",
    date: "OCT2023 - OCT2024",
    desc: "Active participant in technical workshops and competitive coding events at Geeks For Geeks, PDEU, focusing on programming, data structures, algorithms, and web development.",
    skills: [
      "Leadership",
      "Web Development",
      "Reactjs",
      "laravel",
      "Mysql",
    ],
  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_SIpcKantkVGyX97VHKWx9_gsh9m-HvTcRXxeAdeHVA&s=10",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "May 2023 - Present",
    desc: "Contributed to different open-source projects and learn from industry experts",
  },
];

export const achievements = [
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAcQPFPsMCWBbGDMHg441AuJ22GHGvGLyc0wdKwHY5ft3rWaiyb5pgSfhV&s=10",
    award: "Rewarded Amazon Voucher",
    Title: "NVIDIA Nemotron 3 Super Hackathon",
    date: "May 2026",
    desc: "Winner - NVIDIA Nemotron 3 Super Contest: Built Community Navigator, an AI-powered PDF information extraction and RAG chatbot using NVIDIA Nemotron, MongoDB, and Milvus for intelligent document understanding and semantic search. Developed an end-to-end system combining LLMs, vector search, and a web dashboard to enable contextual, conversational access to complex documents.",
  },
  {
    id: 2,
    img: "https://gate2025.iitr.ac.in/img/logos/green-logo.png",
    award: "AIR 2764",
    Title: "GATE 2025",
    date: "Feb 2025",
    desc: "Achieved an All India Rank of 2764 in GATE 2025, showcasing a strong grasp of core technical concepts in computer science. This reflects my problem-solving skills and deep understanding of algorithms, data structures, and machine learning fundamentals.",
  },
  {
    id: 1,
    img: "data:image/png;base64,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",
    award: "Reward INR 40,000",
    Title: "Flood Ai Hackthon IIT Gandhinagar",
    date: "Aug 2024",
    desc:
      "Secured 3rd place at the FloodAI Hackathon organized by IIT Gandhinagar. Developed a comprehensive flood prediction and risk assessment model integrating rainfall forecasts, satellite image analysis, and real-time alerts, helping in disaster preparedness and mitigation.",
  },
  {
    id: 0,
    img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOMAAADeCAMAAAD4tEcNAAAAyVBMVEX///8PdbyMxj8AcrsAabcAcLoAbbkAa7gAbLgAXrMAc7sAZrYAYLQAY7UAYbT5/P6BwSLs8/n0+fyJxTkAW7Lg6/WFwy7u9frV5PG30Ofc6fSHxDPA1uq0zeUvgsLI3O2oxuKLs9jx+Onk8dVcmMzQ4fCgwN94qNNEi8aVutwmfsD3+/JtodCNtdpypNGiwuDO5rTe7sxRkcgAU6+j0Wqw14KXy1S83Zfr9eDW6sDD4KL0+u6y2IXI46uo03O+3pqXy1KdzmJ6vgCMj1XFAAAVB0lEQVR4nO1d6XqizBKW0IBsIiiurAnKEtQMsybfJDNz7v+iDk03m+ASATPzPL4/oiiGLmqvrm56vRtuuOGGG2644YYbbrjhhhtuuOGGG2644YYbbrjhhnagmtlbRZsvPnAkHUD1kxd3nH6wFkR+7CkfNqAOYAoefNkJmCp/7Cu9FRHgrz39g8bVBjZ48CqgIZGagORT4V34Mpujb+WxBV8k+erjawNEhF4V4AAjJkrQkkNdUItn6YPk0Py8uvLwWoHNSOgNvZnxRm86sJKjNV/SRJdMXja8dNXBtQRTwKwxnN5K9CR6kxzNhZJYEk7y4nn42JpebYAtQOIRUT0nltQVHxFhcqTwNnzBhMqiVTpXFcWt2vt3EGHeJOK4AhQ+9KGVWVCIfwshcZumgL2nS2vGOPp3qPRFpHlrEerajKHw5xuWp8cGYqQqJNbXBUgdEybPDKryv/4GqFY1ckkt6fxzwhdVS7+QdWuWvg+CmLqZ6KIjn4ek6+zfyEhfNNiq8afRyJVjvk8FjLsVA2xVqT65VnrR2XwMt26Mnr2F92+znb9nzO+EOlZ7nlv52HHO+K3iR94Gk6gLph6IBHm2r3RCkgjDngFiX6wMgH/u7y7AbLzqEVZPP06TIquLhblaLNRD/sGILXDPBO+JeQJoyQwPKD09CLqkseewXjyyBVvryJXZ3A89AvA8L4rigI0x5gnPXWt7xJjCDr4UJcI6RS+icUPPe9GG6JTGnsbQYmSJlREtrK1Bgz5F0wygAsf1LW01W6iqOltplu+G2808/43pCZ7WWwA7/UD2xOjEhRGNtutI7IzqlsZ5X5k7sQss3vep7hCAJjmOYoBnzxe12ZSkatZ8lfJ/EbIUz6dWVRcd49SwEY2uSelkr98tjS7UJCtwotSFTC0P0keQNDA2J22Imt0axdql2hqO1z3ePPCLFJjGHuA2PaZbGvWBpszZdEDSPAI0RxAc3Y9OatQBrEhCjTX8VPjKwZsbh4nReNETNpdd6lyEY5bGTl61SYYkCIIExu7itNBmPcrtWdyp82ZQcBZqT46jilnXSaiMtWgRq2XMQoLindnxXxyDPfZ704iLUm/UqXs/gEM1p1nEQxbGZsZtliQlv9bFNT60x7tG/+6SEbC17l51AKSQoGj7UgpLN2+RB4iWaFdP7hY6G1Y+k1xEIck34GEpItyJub8JBtUrdowdu937RKcoSCHHeA2Kp6ZXPLKI7K0HLHAqHmgdPlu65bIHuERMqUa1RDcoHWaG0hloPZWphv0dwVprKoxL/KKG7JCYciBsVHuSuPq0ymWt+K98rbqWRABmIBKRa3l8GlcoEUMkmkg1M/ELmqPqeOWzHXv3fUwJ2rLcKAA8M0aBjcklTCRor4ETtjyCZmJxp0Ot8pVwNSFNIZNEYu7kFRqNzycUEqDZSCQtpBNxF/iwVOtQhHNy7ZYhU0QhhwgZTGLziQsdEGSgr/alQS3q4fxKEY/KBCmRikcjVSQbRG4ZXPrUfNaavZYHWfAGGotMIFWkiFbiYV08wSW3JvboCjOUR6kUIpEM2plOXInH/0/Edpsi9nqav87ix2QsiyTDiLlotOS5pkcFcRqcYnNTyAFLAsEoyOSCRiSSbZEY29YjXy4oug2dPwYSkjdnqIweNSUx6DL+kNLigsy2o/NHYCFVUfnUC06xoHJcp1P7ZqaBeuctBGFxFqoHYzpkbji628kJt5I3SpbrdtNEsMUZwRzP+HoUdv2nKmcNQe07C5MWiGDQidzqeFrYR2Ukl8YkdlyD2DBe+YOFaMT5qWwQ9ec3Q8DB3FdFyYYFEImVu9wiJHmmxYEiXb6Eh+RpOujCjcjcwPG3YnJbFzgM54JTv7ocys5gRSqJoey8sqCMsSoGndR3pI1BGYloSgSHJbVbezO1SJht9TnDTm2qymIfSXYc8YSpvVmfPvcS5GyzmFjjSz4jqQjEpo/tNh6YY2UkvdPnXoSCBkbAKn/nMlB25ny76YfKlL2RguMbguko7pBAzrm0GyKHxzrbQPDaja0WHhsU40gHSyrdlUbobH7zdlV+WZHhtB8DmAZrZK7exJLKdeKhFHnmg4ISaNdri5wTbDq1GKQ29ViOcCkkPRIAnExwTSSM8jX7XC1unHikdb9jgyPFukC6vn6OW5La7pb04T/MDA7oznYH5HmzCapN0V1c38UGh+ywHujsT6XUQvMGNN1KsOOXryfjQmOXbOzZpzVdtik20CO6FQ9ClO9UxsYuK4DzkyM3x3y46q0Eq43LrcYlP69gg0MwXRjVd2ANza3RTkbgciUafbr7fONs6Gwr6blEgoFn5aKTGlX66rPzNYD6oqy5pkOZ81PLEAYOvmF6KqqVIPID4PPyLBQHXlNmejADWNgci2aHPa57x3HuTKoCDI+l7MYJrBTgm6RF8M2CuYbFUc5jzBbwnt6+ONnYcXBUp6J6XjqzdjupQWAuEmS3c0dX71EpYJWKar/bmRX7A/rGsmtTqTp2u5ZGv3ofTo40cUzaKTvETLhmzpgi4ZuKa6oE1XHnmixcN8JQZrodEUmWZtHXilVBx4JSgGo7JCv0ac9NjEBaqiJA10vbCP5qy5U3bKStlHla08DTjQTReTzu0VfrOZLcgZ3P/6kg9Y6ddwRFZCcljHqsOGpmYO3TU+/Y8SqKGFuSuaaLdFmAS1+Zd7w4Ang490Sb6qzoV4tZgFs4PbJpJef++cwTfer8CTF157cQmdtodXs6Hdcgynk5k5Nret8HL9yAIZwaAQpZEQh8c8k24T2dpibnQBftWbj7sf/Jw8v318qHsSfmSgs7tnxs1DmKMfa5G/G7qaSG43Z6EmYpjU1cx8P/7kvHj1+Gy+Vy+HXvND2ONvqFeQ4vjT5IqkxkujIobMedzdMyB9fEHLxN/ise3o3uIJZfqtcqXMZOLw3bnUonpv00q/FlEa5UnjDaZfeySVZwP7x7zI9+Le8QhmVrlNzPLNbJtCQxeKVRRTjVnI0vmwmVPnPrgsHKXEezBPnrskDkXYpRmZEJjdl1sji5GoD4uB/KBhcOZxYKIF9us81oPGsy4hDuh6OMyMdhRuRd6SSkF+meF2lpHmkKWTxRGYTwpNVn6+IBTTeMkO66kEXktY375+PrKCPycXKURgqvBQjJAo0EXzpTGyduo1kipHtilPj8iGyHxlgjMyJ/Z7L6Vr4oXWSZXeQjsTd53UoKZHpC4o7T0mpTGmNGZkQ+pcI6LAcHWAP7VnKkFW0O1UhTaqBoIWAj1FLZGo0/YsJGd8iFvCFpHX4vn7JGNKaTKiVRbXVKUNEjnvWyrV7SYk7zwuOf2CmOligYeBlOJsPl094ZftrihPRM4zMS6XbrktZno7iUOKexafr4nDBvgiO4h+dqEJvVqnHNw+dxN3C/5XRkUQ6bjJTGRnFOAuT5J58OnpBZ0rR1RAsARVF9urLqSlbarNhn+th86vE7iuCG+yLae8BkZzY8r3KavmtXe63lMQ9oIjC8qJXGvfy6J5d6n8IPbE73TU3vN6Yxk5lTPUCquN75RBQ6ZCsFICfzxEzjCm/qFiflEO77ENOYpaqnhCbZPoCYww07mo4JYpvRCBoXBl/SWHx0VzA4L5MJOpIKDpE52kpmDuL7TcW8Ji6X1dnOT3ss8mijeQn5Rx6o5vL6c3KHaVQLNB7XDA3278PtLkjrwqFIjjAQhT4iaZ1F/3Rz/c6CuDh3vHuKg57Hp/jN3RD5E5PJaSSOdhnpMHodx2HBcXYfgQHiCGDhoDX6WY7cxuzj9+VdgcrhcjJMfOYQhXilZOqoasywGmbz3e+FhTdodBKHuMoEqIVpq0+FjKOACaKxlEzVmZ32fGK6V4aW7G4k50rSb3yNx3oacYbllZIpgt4Pw3ftzSmlWy6Z44QmMndazRsq/4xqKBx9Q1/mV8JGruQYpk4yUdBOM4CNUzVc9MoCnTYmA0oKmdGI6nMyIPbAhJlLll2AdgJqJ/+QRQcy0EapdkFLWugHfK4T1uVL8l1u3TLAtuSppMysCFBcH6ZCMrQVSnNCTZ73PCBgrhWsXfOOyvs6GieoOreX9yPDQzGABgxNplmyBoegfWYi32y4h40feW5quhe5CLUwkVwnqxOUU3pclcYCkC9JZtOnmu3xrBhsL91PqoKcj01LATG+HTSrUkUdy2KLrH1uElSLo1vbhDcqmPTG/+xr1bDiwlUpyqkClZbNzOdLawo02VSqjDyaa8F7/KoK6/I1+aZOHXPgKoSLLYLi00LYYvNAQSGbC+tT1ejgaDU4qo54L0hEqbQBbFu77pooLs6vxDWer69zHskX6lF1xDdXS9ICCzDbVrqVlLlDM2gJciGObNwx91ChcYSyLJ8+QiJHIZrQZsIew9CGO2/ISNmKeDaI8JpjM7/FjQtXPyo04uTROCaqjJWcM8U2TzF9h2IHjdYL62Mh8NUekRLE5ddvuryjkCanfEw+XxwT1bQTwi4Gk7K+bWIdZB/KQcinHrYgrE2TyAqNy1/J50etatoIMWh73aWGWh4gVgXX9a7Nbquo0DhEQQ53RFT7OP9Yt91OJzFJBI4oKtj1hu5j3+bgWdb5kQCATEmj214S6TBKb+EHaMJ9VzB6zRi5XwnAVfNjFieV1B1/5P9egjnv2hzLR1ZCYzGWbKaRz+U4B6fHqyMWJ+0EkJiW22dlmuKZUMtyqWKppVED5suyjo0ReZDEbMbKR5suZ3a9cRQwi5PT4nExR2/U0/Zz9D42Zk0rUzEhVhmTPlIW3mowjFoUJ+ebbLZWLujgeWTvIBu5bJm+IyLxMZ2BCJdIzdnWm8/LNezL6wElUcVZlXaYjVmio/HZ9OfUpwTC8lqddUVmLSxo5OWT8+VQDtdViYNGNZMYiRCL4akWgTYnz00PmexS1ezi5fNPRT5O0ETk4Wg8fw7AltljW9hePLCI+PQRI3ZhKGke8G68FdQRu//DSVXuLDSw11gq8W3FA7IjkG7aJCoVS7yXliGLFmeJJNU4ZHDynWWn9P5O8uuWHjUkbweMH3vG9FgvxluXbe1ejHKwTd1Uq6pYUPOg0aP2C0kr65LLV0GIttJTxJyYkom/aMuuQsVqiKo4B10jyCcCXBpfrP1dwpKtQjciVATkmkpmh6MviFtzNk5+Jh9MqQM2lc+XJVkAJ8PW57CTBVkwlFKdz8hQ74pEXrBL4GtmVZe4Ue6AMnIgr6nEnCbxldY808GKLEtQp6FA7/BFSnEl9e6YLpPUtAHZqc+MSSIPiVWayz2VEohG6/tMBMZGBH7GsCldFC36nZ1XWd0x5aJbb2/6hf1mpxxXWKBkirtg4La7YNgElOgWdaDQwka8u4st00XcK+/WJ8Z8YdpxSpBpirz2/TV85NkGtLuL51bc7s0O2aVx9d/DyTStSls66kmkiEItfhqQqW2zWZ6nSXi/Q6JVRqqFVBGzM6IuJPI/JKmjtE8+rCORK+2RDTckLvooHyZaq5YWddTAxHuhSUHJFNJnBzxfEouz/I0q/5JXE6Vy/aA4oaKSZHknO03Y9RSis+V7tpCulZHLtpAyzvNZr6hLBbnFnhrUWFSq3AFkxgauX66QOQLFXxoqn8LUYPNiygKU/DZ51gZND7DmuLzDjXE6qLp+CtglPbPicyqWW7OtjrZhmPN0UQdWeyM8oy7wCHuQJ9jYSE4lgONoxi3HTVuQe+C51Q4dhyFt2agsH9o+kSdrrt9Go+EbXnM15/bllGTITdl+ywadkzjjB10/iyUQKo1yJl8mkq4sbCvjy2T4BfdYyxFT/i1H8ZXHCOtJkwMmUWbCzbjjfS7Mmsljc0/auKM7eX753xumUHH5klkmaRD4+/dHcaCc0JhEiTDgNp4t7/N4Dmb0flPU4SfNfPmOF81N7X4uphxJMbTnV381T55dk3peyYMuX+EAcf3nX6rEXspAggOBZLqUU3UZRCEXk9cHZLQxa9yAGiXKnqm4HMiQl45KMdd/knLVi9OUdfBsRfcGoM8wADAM54X+gVlgBT1iiePLou8ZMPhgu96KvQbbfRfAMcGBuXTFgtDnmrk4sqWT5NMU0tJyuDaHrexxztHm4I/h9e3tNX1fdeUcCC4umCkbCik5bey3iUlwP+Rr7QHx391kNJpkKxnVoBJ1cgyxuyTairUVmzG+jpgpc7XnzqDpisLyU5evRmU0Hb4zNZD0CGCLS3G1v42utnlftgolXya+ImoSCBIQ9vmJrBbSfWykOX5br67Tqz3OPK2PTorrwWxQV3iiAOdqp4VW1h2GSavTHF3MrR7vD/+sQ9TwsZe5tIpmUgxjuPPFITuqzKwwAHQeFVDFzaQfvg2Ho9cDP+0Uv5E+/tn7WDOY+jopB529EW4sbSZPE2IlZaqutJ3tBHTSepvLd+mpgw9DeKXhryvSluJ+shyNlqP/Kl/MgwNUorCGhs6fpkiSpOn4XT9+Wz6d2nt+1ze8xq56pe7x+OvPn5fab+ZGrV7ukVt7I2KpLlOYLa+fnLtly7VgOuBYY98hkAyx2bea/2EaK8t5Px6yT4BDMxgHOEvzUd2EbTrzU9mb5W/AyuXOJZOLs0dvXe/4nhNGTt5qv/wLsNoYDHOCTi42Q6RzpK//dTKZVDaf+asAVyfAR7KTNUYmsbKEs54dz+wfPz1/TBDwLizmm9CL5RGAfpw5Mkw/cSBEtF2bH5AJdglFXpjaXI8x11bq1R6tesMN5+HLy6fH02c9v529vd7fh/vhZDi8OxyjPH5K4tDvww9JLNrB8/Dt6eso2bTi7efL0zPi6f3Dp+cnuJq89/V/Cf2f/m4HeBwJg+4ndzC4Xg5j/EKfQsD8+hnN0d0Pf3/oMBvhT9JEtRxCMr7dPzyh+fHXyddPD6+Q8h9DlIEuJ2do7V+KJeyhfp78htTA+tbjEiaCTwk7E/onk+S8L8N/1uj8mIxikzOBW408IJX7CXUTSWhC4x+UUGS7kfx7eJq8vb7d/YHjx5r3OnyBJubtx6eXCVx8hC3qz3+Xxp/5HodPw6Rq8B3y8QGyN7E5cOocfjwa/gNhdz1+56ntC2JYkuz+GP5+Tf3In8m356ff/7DveMpT2++QpY9vE2hHYxubff74B/qRnx8wuPbxdbK8+z0ZJvvKPQ6LWx8+PH/6iKJbB3j9+uXbXVrJ+9/kYwdzDfy7Dv+GG2644YYbbrjhhhtuuOGGG2644YbO8X/7BI/sHRlx8wAAAABJRU5ErkJggg==",
    award: "Grant INR 62,000",
    Title: "SRP PDEU IIC",
    date: "Sep 2024",
    desc:
      "Received a ₹62,000 grant from PDPU IIC for developing SignToSpeech and vice verse, a real-time sign language to speech translation system. The project integrates deep learning and AR technology to bridge the communication gap for individuals with speech and hearing impairments."
  },
];
export const education = [
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMNW1DwS6DoBYNgyrnKtG9i3B3mn0I1YkvAw&s",
    school: "Pandit Deendayal Energy University, Gandhinagar",
    date: "Oct 2022 - May 2026",
    grade: "9.65 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Pandit Deendayal Energy University, Gandhinagar. I have completed 4 semesters and have a CGPA of 9.65. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT6w9cjeKwHZAlv5J1JizbjthI0GVtsn-GqTdPtLbxWlQ&s=10",
    school: "Harvard Business School",
    date: "Aug 2025 - Oct 2025",
    grade: "Cerified",
    desc: `Completed the Aspire Leaders Program, where I developed leadership, communication, and critical thinking skills through a global learning community. The program strengthened my ability to collaborate across diverse teams, solve complex problems, and lead with purpose and integrity. It also enhanced my career readiness through personal branding, networking, and professional development sessions.`,
    degree: "Aspire Leaders Program",
  },
  {
    id: 1,
    img: "https://imgur.com/iCUonv8.jpg",
    school: "PP Savani VidhyaBhavan, Surat",
    date: "Apr 2021 - Apr 2022",
    grade: "99.45(88.6%)",
    desc: "I completed my class 12 high school education at PP Savani VidhyaBhavan, Surat, where I  learnt advanced concepts in physics, chemistry, and mathematics. This includes topics like calculus, electromagnetism, organic chemistry, and more. Practical applications, experiments, and problem-solving skills are emphasized, preparing you for higher education or careers in engineering, technology, and the physical sciences",
    degree: "HSC(XII),PCM(Physics, Chemistry, Maths)",
  },
  {
    id: 0,
    img: "https://imgur.com/iCUonv8.jpg",
    school: "PP Savani VidhyaBhavan, Surat",
    date: "Apr 2019 - Apr 2020",
    grade: "99.81(90.66%)",
    desc: "I completed my class 10 education at PPSavani Vidhyabhavan School, Surat, where I studied essential subjects like Mathematics, Science, Social Studies, and Language, building a strong foundation for further education",
    degree: "SSC(X)",
  },
];

export const projects = [
  {
    id: 13,
    title: "Community Navigator",
    date: "May 2026 ",
    description:
     "AI-Powered RAG Chatbot: Developed an intelligent PDF-based chatbot using NVIDIA Nemotron-3, MongoDB, and Milvus for document understanding and semantic search. Implemented a RAG pipeline to provide context-aware, accurate answers from uploaded documents. Built an interactive web dashboard for PDF extraction, vector search, and conversational querying. Winner of the NVIDIA Nemotron-3 Super Contest."
     ,
    image:
    "https://media2.giphy.com/media/v1.Y2lkPTc5MGI3NjExbnczYWh6dW81d24yeXh0cG5seXNiaHI2azBwdWllc3ppMDNocTJ5MyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/Jxta9oQCFzlUnIJgJG/giphy.gif",  
    tags: ["RAG", "Chunking", "Nemotron 3", "Vector DB",],
    category: "machine learning",
    github: "https://github.com/DeepMathukiya/community_navigator",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
    ],
  },
  
  {
    id: 13,
    title: "Temperature Forecasting using LSTM",
    date: "Jun 2025 ",
    description:
     "Worked on a temperature prediction system during a research internship at the India Meteorological Department (IMD), focusing on daily maximum temperature forecasting. Applied various time series forecasting models such as ARIMA, SARIMA, and LSTM to predict temperature trends. Conducted thorough exploratory data analysis and preprocessing to ensure data quality and stationarity. Compared model performances and demonstrated LSTM’s superiority in capturing long-term dependencies. The project aids in climate study and agricultural planning through accurate temperature trend analysis."
     ,
    image:
    "https://i.ibb.co/ds2kwPw8/case1.png",  
    tags: ["Time Series Forecasting", "SARIMAX", "LSTM", "Pandas", "Matplotlib", "Seaborn", "Keras","NumPy"],
    category: "machine learning",
    github: "https://github.com/DeepMathukiya/InverterOpVolt",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
    ],
  },
  {
    id: 12,
    title: "Inverter Output Voltage Prediction",
    date: "Jan 2025 ",
    description:
      "Developed a system for predicting output voltage using various machine learning algorithms, including Decision Tree, XGBoost, and Neural Networks. After training and evaluating these models individually, I applied Particle Swarm Optimization (PSO) to fine-tune their hyperparameters and identify the optimal parameter set for improved accuracy. To further enhance prediction performance, I implemented a stacked ensemble approach that combines the strengths of all individual models. This ensemble model leverages the complementary capabilities of each algorithm, resulting in a more robust and reliable voltage prediction system."
    ,
    image:
      "https://www.googleapis.com/download/storage/v1/b/kaggle-user-content/o/inbox%2F642765%2Fff29577cce2f7018785f91a5d1a3805c%2FScreenshot%20from%202020-10-27%2011-39-16.png?generation=1603795173235540&alt=media",
    tags: ["Particle Swarm Optimization", "Ensemble Learning (Stacked Ensemble)", "Pandas", "Matplotlib", "NumPy"],
    category: "machine learning",
    github: "https://github.com/DeepMathukiya/InverterOpVolt",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
    ],
  },

  {
    id: 11,
    title: "SignToSpeech",
    date: "Oct 2024 ",
    description:
      "Sign Language to Speech Conversion and Vice a versa : jetson device that facilitates real-time translation between Gujarati sign language and speech, utilizing AR technology to visually represent signs, enhancing communication between signers and non-signers."
    ,
    image:
      "https://imgur.com/AqGYGmu.gif",
    tags: ["TensorFlow", "Pandas", "Matplotlib", "JavaScript", "Flutter", "Keras", "OpenCV", "NumPy"],
    category: "android app",
    category2: "machine learning",
    github: "https://github.com/DeepMathukiya/SignToSpeech",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
      {
        name: "Ansh Sardhara",
        img: "https://imgur.com/LoEqpGd.jpg",
        linkedin: "https://www.linkedin.com/in/ansh-sardhara/",
        github: "https://github.com/ansh-2411",
      },
    ],
  },
  {
    id: 10,
    title: "FloodPre",
    date: "September 2024 ",
    description:
      "Flood Prediction Application: A web app providing real-time flood risk analysis through flood mapping, machine learning-based flood-prone region predictions, and user alerts for early warnings, enabling proactive decision-making.It also Takes Picture from satelite and highlite the flooded area."
    ,
    image:
      "https://imgur.com/i4aoKu2.gif",
    tags: ["TensorFlow", "Pandas", "OpenCV", "NumPy", "Matplotlib", "JavaScript", "React.js"],
    category: "web app",
    category2: "machine learning",
    github: "https://github.com/DeepMathukiya/FloodAiHackthon",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },{
        name: "Harsh Rajput",
        img: "https://media.licdn.com/dms/image/v2/D4D03AQEGI-tQGssFaw/profile-displayphoto-shrink_800_800/B4DZc1l5gSGwAc-/0/1748950819679?e=1758153600&v=beta&t=u74ttu4fGN-Bdm8C8k07kZxzdc6f7FoToBy9yTduj-E",
        linkedin: "https://www.linkedin.com/in/harsh-rajput-115430208/",
        github: "",
      }
    ],
  },
  {
    id: 9,
    title: "AgrisenseAI",
    date: "August 2024 ",
    description:
      "Smart Agriculture Assistant: An AI-driven platform designed to assist farmers in identifying crop diseases using a CNN model for leaf analysis, with an integrated AR feature for scanning crops and offering detailed disease insights and solutions."
    ,
    image:
      "https://imgur.com/6jkSHxl.gif",
    tags: ["TensorFlow", "Pandas", "OpenCV", "NumPy", "Matplotlib", "React.js"],
    category: "web app",
    category2: "machine learning",
    github: "https://github.com/DeepMathukiya/AgriSense-Ai",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
      {
        name: "Ansh Sardhara",
        img: "https://imgur.com/LoEqpGd.jpg",
        linkedin: "https://www.linkedin.com/in/ansh-sardhara/",
        github: "https://github.com/ansh-2411",
      },

    ],
  },


  {
    id: 8,
    title: "SQL Generator",
    date: "April 2024",
    description:
      "Effortlessly create complex SQL queries with our intuitive SQL Query Generator. Designed for both beginners and experts, our tool simplifies database interaction, ensuring accurate and efficient query building without the need for deep SQL knowledge.",
    image:
      "https://imgur.com/3l7eKtm.jpg",
    tags: ["GenerativeAi", "MySql", "Flask", "HTML", "Bootstrap", "Firebase", "CSS",],
    category: "web app",
    category2: "machine learning",
    github: "https://github.com/DeepMathukiya/SqlQueryGenerator",
    webapp: "https://sqlquerygenerator.onrender.com",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
      {
        name: "Ansh Sardhara",
        img: "https://imgur.com/LoEqpGd.jpg",
        linkedin: "https://www.linkedin.com/in/ansh-sardhara/",
        github: "https://github.com/ansh-2411",
      },
      {
        name: "Jenil Kakadiya",
        img: "https://imgur.com/CLj9JB7.jpg",
        linkedin: "https://www.linkedin.com/in/jenil-kakadiya-782933294/",
        github: "https://github.com/jenil-kakadiya",
      },
    ],
  },
  {
    id: 7,
    title: "Medecio",
    date: "Oct 2023 ",
    description:
      "Medecio: is a web platform designed for doctors and patients. Doctors can register with their clinic names, manage patient entries with a receptionist inputting basic details. Doctors can search patients by email, access previous records and descriptions, and input prescriptions via speech-to-text in the particular day patient record. In the patient section, users can predict diseases and book appointments with nearby top-rated doctors specializing in their predicted ailment.   "
    ,
    image:
      "https://imgur.com/d85Vkrl.jpg",
    tags: ["HTML", "CSS", "PHP", "MYSQL", "JavaScript", "Xampp", "MailSender"],
    category: "web app",
    github: "https://github.com/DeepMathukiya/medecio",
    webapp: "https://github.com/DeepMathukiya/medecio",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
      {
        name: "Ansh Sardhara",
        img: "https://imgur.com/LoEqpGd.jpg",
        linkedin: "https://www.linkedin.com/in/ansh-sardhara/",
        github: "https://github.com/ansh-2411",
      },
    ],
  },
  {
    id: 6,
    title: "Heart disease Prediction",
    date: "Oct 2023",
    description:
      "A machine learning technique predicts whether a person is suffering from heart disease based on several basic attributes such as age, gender, type of chest pain, cholesterol levels, heart rate, and ST depression. The system takes user data from a form and generates an output upon submission of the data. ",
    image:
      "https://imgur.com/fMsHwR4.jpg",
    tags: ["Scikit-learn", "NumPy", "Flask", "HTML", "Bootstrap", "Firebase",],
    category: "machine learning",
    category2: "web app",
    github: "https://github.com/DeepMathukiya/heart-disease",
    webapp: "http://heart-9dh6.onrender.com/",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
    ],
  },

  {
    id: 5,
    title: "Text To Music",
    date: "Aug 2023 ",
    description:
      " This Java-based Android application enables users to choose a .txt file from their device. Upon selecting a text file, the application utilizes the Python gTTS library to convert the text content into an .mp3 file. ",
    image:
      "https://imgur.com/jvxqCBd.gif",
    tags: ["Java", "XML", "Android Studio", "Chaquopy"],
    category: "android app",
    github: "https://github.com/DeepMathukiya/TextToMusic",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
    ],
  },

  {
    id: 4,
    title: "IMusic",
    date: "Aug 2023",
    description:
      "A media player android application, developed in Java, serves as a media player that showcases a comprehensive list of all .mp3 files accessible on the device. Upon a user's selection of any mp3 file from the list, the app initiates playback of the corresponding music. This media player is equipped with fundamental functionalities such as play, pause, a seek bar, as well as next and previous buttons.",
    image:
      "https://imgur.com/n4xS6jq.gif",
    tags: ["Java", "XML", "Android Studio", "OOPS Structure", ""],
    category: "android app",
    github: "https://github.com/DeepMathukiya/Imusic",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
    ],
  },
  {
    id: 3,
    title: "Diabetes",
    date: "june 2023",
    description:
      "A machine learning model and its user-friendly interface for predicting diabetes risk. Users can input relevant health parameters, and the model provides personalized risk assessments, aiding in early detection and preventive measures.", image:
      "https://imgur.com/YtslgsK.gif",
    tags: ["React Native", "JavaScript", "Axios", "Flask", "HTML", "Bootstrap"],
    category: "web app",
    category2: "machine learning",
    github: "https://github.com/DeepMathukiya/Diabetes",
    webapp: "https://diabetes-6dzs.onrender.com/",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
    ],
  },

  {
    id: 2,
    title: "CharitAble",
    date: "Apr -2023",
    description:
      "A donation platform is available where users can contribute funds for specific purposes such as animal care, education, hospitals, and supporting impoverished individuals. ",
    image:
      "https://imgur.com/w1Dm7kA.jpg",
    tags: ["HTML", "CSS", "PHP", "MYSQL", "JavaScript", "Xampp"],
    category: "web app",
    github: "https://github.com/DeepMathukiya/charitAble",
    webapp: "http://charitable.epizy.com/",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
    ],
  },
  {
    id: 1,
    title: "Agrotech",
    date: "Nov -2022",
    description:
      "AgroTech is your comprehensive online resource, offering a wealth of information on pesticides, fertilizers, and crops. Explore our extensive databases to gain insights into effective pesticide usage, safety guidelines, and the latest fertilization strategies. Our detailed crop encyclopedia provides essential information for various crops, empowering both seasoned farmers and gardening enthusiasts. Stay ahead of the curve with updates on agri-tech innovations, and connect with our vibrant community to share experiences and seek valuable advice. AgroTech is not just a website; it's a dynamic platform fostering knowledge, growth, and sustainability in agriculture. ",
    image:
      "https://imgur.com/lWBksmi.jpg",
    tags: ["HTML", "CSS", "PHP", "MYSQL", "Bootstrap", "Xampp"],
    category: "web app",
    github: "https://github.com/DeepMathukiya/Agrotech",
    webapp: "http://kissan.rf.gd/",
    member: [
      {
        name: "Deep Mathukiya",
        img: "https://imgur.com/9sH6f9a.jpg",
        linkedin: "https://www.linkedin.com/in/deepmathukiya/",
        github: "https://github.com/DeepMathukiya/",
      },
    ],
  },
];

